import { BaseModal } from './BaseModal'
import { Difficulty } from '../../hooks/gameReducer'
import { ChampionshipContent } from '../championship/ChampionshipContent'

interface Props {
  isOpen: boolean
  handleClose: () => void
  userId: string
  difficulty: Difficulty
}

export const ChampionshipModal = ({
  isOpen,
  handleClose,
  userId,
  difficulty,
}: Props) => {
  return (
    <BaseModal title="Heti Bajnokság" isOpen={isOpen} handleClose={handleClose}>
      <div className="mt-4">
        <ChampionshipContent
          userId={userId}
          difficulty={difficulty}
          isVisible={isOpen}
          showDifficultySelector={true}
        />
      </div>
    </BaseModal>
  )
}
